import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import React from 'react';
export function ThemeProvider({ theme, children }) {
    return React.createElement(MUIThemeProvider, { theme: theme }, children);
}
